import type { JSX } from 'react';
import React from 'react';
import type { OptionProps, SingleValueProps } from 'react-select';
import { components } from 'react-select';

import type { ICampaignAttributes } from '@feathr/blackbox';
import type { Campaign } from '@feathr/blackbox';

import { getCampaignIcon } from '../CampaignIcons';

import styles from './SelectOptions.css';

import noImg from 'images/no-img.png';

export function CampaignIconOption<T extends ICampaignAttributes>(
  props: OptionProps<T>,
): JSX.Element {
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex' }}>
        <div className={styles.contentWrapper}>
          {getCampaignIcon((props.data as ICampaignAttributes)._cls)}
        </div>
        <div className={styles.contentWrapper}>
          <span>{props.data.name}</span>
        </div>
      </div>
    </components.Option>
  );
}

export function CampaignModelIconOption<T extends Campaign>(props: OptionProps<T>): JSX.Element {
  const campaign = props.data.toJS();
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex' }}>
        <div className={styles.contentWrapper}>{getCampaignIcon(campaign._cls)}</div>
        <div className={styles.contentWrapper}>
          <span>{campaign.name}</span>
        </div>
      </div>
    </components.Option>
  );
}

export function CampaignOption<T extends ICampaignAttributes>(props: OptionProps<T>): JSX.Element {
  return (
    <components.Option {...props}>
      <div style={{ display: 'flex' }}>
        <div className={styles.contentWrapper}>
          <img
            alt={''}
            src={`${props.data.template.thumbnail_url || noImg}`}
            style={{ width: '100px' }}
          />
        </div>
        <div className={styles.contentWrapper}>
          <span>{props.data.name}</span>
        </div>
      </div>
    </components.Option>
  );
}

export function CampaignSingleValue(props: SingleValueProps<Campaign>): JSX.Element {
  const campaign = props.data.toJS();

  return (
    <components.SingleValue {...(props as any)}>
      <div style={{ display: 'flex' }}>
        <div className={styles.contentWrapper}>{getCampaignIcon(campaign._cls)}</div>
        <div className={styles.contentWrapper}>
          <span>{campaign.name}</span>
        </div>
      </div>
    </components.SingleValue>
  );
}
